import React, { useEffect, useRef } from 'react';
import { useCanAccessPortal } from '../../../hooks/usePortalPermissions';
import { useProjectsUiStore } from '../../../portals/projects/projectsUiStore';
import { useUiStore, DEFAULT_DEV_VIEW } from '../../../stores/uiStore';
import { requestNavigation } from '../../../stores/navGuard';
import ProjectsChooser from './ProjectsChooser';
import { selectProjectWorkspace } from './projectsNavigation';

export default function ProjectsChooserMount() {
  const allowed = useCanAccessPortal('projects');
  const access = useRef(allowed);
  access.current = allowed;
  const open = useProjectsUiStore(s => s.chooserOpen);
  const close = useProjectsUiStore(s => s.closeChooser);
  useEffect(() => { if (!allowed && open) close(); }, [allowed, open, close]);
  const select = view => selectProjectWorkspace(view, {
    canAccess: () => access.current, close, guard: requestNavigation,
    projects: useProjectsUiStore.getState(),
    // requestNavigation has already authorized this atomic destination change.
    navigate: () => useUiStore.setState({ tab: 'projects', entryPhase: 'app',
      devView: DEFAULT_DEV_VIEW, analyticsView: null, settingsView: null,
      settingsPanel: null, openPortalDropdown: null, showHamburgerDrawer: false }),
  });
  return <ProjectsChooser open={allowed && open} onClose={close} onSelect={select} />;
}
